/** Low quality: ?lq=1 or press L. Shadows / floaters / DPR stripped for stream FPS. */
function fromQuery(): boolean {
  try {
    return new URLSearchParams(window.location.search).has("lq");
  } catch {
    return false;
  }
}

function preferLow(): boolean {
  if (fromQuery()) return true;
  try {
    if (new URLSearchParams(window.location.search).has("hq")) return false;
  } catch {
    /* ignore */
  }
  const coarse = window.matchMedia?.("(pointer: coarse)")?.matches ?? false;
  const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  return coarse || ios || window.innerWidth < 700;
}

export const quality = {
  low: preferLow(),
};

export function setLowQuality(on: boolean) {
  quality.low = on;
}

export function maxDpr(): number {
  return quality.low ? 1 : Math.min(window.devicePixelRatio || 1, 2);
}
